
import { isString, map } from 'lodash';
import { User } from '../user/user';
import { RecordLink } from '../record-link/record-link';
import { DataLink } from '../data-link/data-link';
import { Link } from './link';
import { LinkGroup } from '../link-group/link-group';
import { INPIInfo } from '../inpi';

export interface CreateSLEntityDossierInput {
  sl_entity_id: string
  sl_entity_version: number
}

export interface UpdateSLEntityDossierInput {
  sl_entity_version: number
}

interface DossierSLEntity {
  id: string
  version: number
  name: string
}

export class Dossier {
  id: string
  name: string
  is_archived: boolean
  
  link_groups: LinkGroup[]
  links: Link[]
  link: Link

  created_at: number
  created_by: User

  updated_at: number
  updated_by: User

  version: number

  slEntity?: DossierSLEntity
  sl_entity_version?: number

  inpi?: INPIInfo

  constructor(data: any = {}) {
    Object.assign(this, data);

    if(this.created_by) {
      this.created_by = new User(this.created_by);
    }

    if(this.updated_by) {
      this.updated_by = new User(this.updated_by);
    }

    if (this.link_groups) {
      this.link_groups = map(this.link_groups, lg => new LinkGroup(lg));
    }

    if(this.link) {
      this.link = new RecordLink(this.link);
    }

    if(this.links) {
      this.links = Dossier.createLinks(this.links);
    }
  }

  static createLinks(data: any[]): Link[] {
    return map(data, l => {
      if (l.__typename === 'RecordLink') {
        return new RecordLink(l);
      }
      else if (l.__typename === 'DataLink') {
        return new DataLink(l);
      }
      else {
        return null;
      }
    });
  }

  toCreateDossierInput() {
    let rootLink: RecordLink = this.links[0] as RecordLink;

    return {
      fields: map(rootLink.modelFields, f => f.toRecordFieldInput()),
      record: rootLink.record.toCreateRecordInput()
    };
  }
}
